import { call, takeEvery, put, getContext } from "redux-saga/effects"
import { createActions } from "reduxsauce"
import { post } from "api"
import { isFunction } from "lodash"
import { Creators as notificationCreators } from "modules/notifications/model"

export const { Types, Creators } = createActions({
  create: ["resource", "url", "payload", "options"],
  createSuccess: ["resource", "id", "result", "payload"],
  createError: ["resource", "id", "error", "payload"],
}, {
  prefix: "ompnt/modules/creator/",
})

// By default, non-graphql id is the url
function* createSaga({ resource, url, payload, options }) {
  try {
    const result = yield call(post, url, payload)
    yield put(Creators.createSuccess(resource, url, result, payload))
    if (options?.onSuccessTo) {
      const { navigate } = yield getContext("router")
      yield call(navigate, options.onSuccessTo)
    }
    if (options?.onSuccess) {
      let message
      if (isFunction(options.onSuccess)) {
        message = options.onSuccess(result)
      } else {
        message = options.onSuccess
      }
      yield put(notificationCreators.add("success", null, message))
    }
  } catch (error) {
    yield put(Creators.createError(resource, url, error, payload))
    if (options?.onError) {
      yield put(notificationCreators.add("error", null, options.onError))
    }
  }
}

export function* saga() {
  yield takeEvery(Types.CREATE, createSaga)
}
